import React from 'react'
import { Carousel } from 'antd';
import './view.css'

export default function ViewIndex() {

    const items = [
        {
            key: 1,
            title: 'TUT虛擬數位形象大使',
            content: '藉由「TUT虛擬數位形象大使」徵稿活動匯集師生的創意，共同徵選出能代表南應大之虛擬數位「形象大使」。透過更具活力與親切感的形象大使IP，宣傳南應大的校園文化與特色，陪伴、支持與豐富同學的校園生活，後續預期應用於LINE貼圖、人型活動公仔、校園禮品等…。另外，也將代表南應大也積極協助社會與參與企業工作，宣傳南應大的品牌形象與知名度。'
        },
    ]
    return (
        <div id="index" className="indexBlock">
            <Carousel>
                {
                    items.map((item) => {
                        return (
                            <div className="container-fluid" key={item.key}>
                                <div className="content" >
                                    {item.content}
                                </div>
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}